/**
 * Created by dx.yang on 2017/2/22.
 */
var moment = require('moment');

//IP转成整型
function ip2int(ip) {
    var num = 0;
    ip = ip.split(".");
    num = Number(ip[0]) * 256 * 256 * 256 + Number(ip[1]) * 256 * 256 + Number(ip[2]) * 256 + Number(ip[3]);
    num = num >>> 0;
    return num;
}

//整型解析为IP地址
function int2ip(num) {
    var str;
    var tt = new Array();
    tt[0] = (num >>> 24) >>> 0;
    tt[1] = ((num << 8) >>> 24) >>> 0;
    tt[2] = (num << 16) >>> 24;
    tt[3] = (num << 24) >>> 24;
    str = String(tt[0]) + "." + String(tt[1]) + "." + String(tt[2]) + "." + String(tt[3]);
    return str;
}

var sortFunctionList = {
    ip: function (key, state) {
        if (state === 'up') {
            return function (a, b) {
                var aVal = _.get(a, key);
                var bVal = _.get(b, key);
                if (aVal === null || aVal === undefined) {
                    return -1;
                }
                if (bVal === null || bVal === undefined) {
                    return 1;
                }
                return ip2int(aVal) - ip2int(bVal);
            }
        } else {
            return function (a, b) {
                var aVal = _.get(a, key);
                var bVal = _.get(b, key);
                if (bVal === null || bVal === undefined) {
                    return -1;
                }
                if (aVal === null || aVal === undefined) {
                    return 1;
                }
                return ip2int(bVal) - ip2int(aVal);
            }
        }
    },
    string: function (key, state) {
        if (state === 'up') {
            return function (a, b) {
                var aVal = _.get(a, key);
                var bVal = _.get(b, key);
                if (aVal === null || aVal === undefined) {
                    return 1;
                }
                if (bVal === null || bVal === undefined) {
                    return -1;
                }
                aVal = aVal.toString()
                bVal = bVal.toString()
                return aVal.localeCompare(bVal);
            }
        } else {
            return function (a, b) {
                var aVal = _.get(a, key);
                var bVal = _.get(b, key);
                if (aVal === null || aVal === undefined) {
                    return 1;
                }
                if (bVal === null || bVal === undefined) {
                    return -1;
                }
                aVal = aVal.toString()
                bVal = bVal.toString()
                return bVal.localeCompare(aVal);
            }
        }
    },
    number: function (key, state) {
        if (state === 'up') {
            return function (a, b) {
                return _.get(a, key) - _.get(b, key);
            }
        } else {
            return function (a, b) {
                return _.get(b, key) - _.get(a, key);
            }
        }
    },
    date: function(key, state) {
        if (state === 'up') {
            return function (a, b) {
                return moment(_.get(a, key)).isBefore(_.get(b, key)) ? -1 : 1;
            }
        } else {
            return function (a, b) {
                return moment(_.get(b, key)).isBefore(_.get(a, key)) ? -1 : 1;
            }
        }
    }
};


// 计算当前浏览器的滚动条宽度
let getPaddingRight = function () {
    let w1, w2, outer, inner;
    try {

        outer = document.createElement('div');
        inner = document.createElement('div');
        outer.appendChild(inner);

        outer.style.display = 'block';
        outer.style.position = 'absolute';
        outer.style.width = '50px';
        outer.style.height = '50px';
        outer.style.overflow = 'hidden';

        inner.style.height = '100px';
        inner.style.width = 'auto';

        document.body.appendChild(outer);

        w1 = inner.offsetWidth;
        outer.style.overflow = 'scroll';

        w2 = inner.offsetWidth;

        if (w1 === w2) {
            w2 = outer.clientWidth;
        }

        document.body.removeChild(outer);
    } catch (e) {
    }
    return w1 - w2;
};


function removeHTMLTag(str) {
    if (!str) {
        return str;
    }
    if (!str.replace) {
        return;
    }
    str = str.replace(/<\/?[^>]*>/g, ''); //去除HTML tag
    str = str.replace(/[ | ]*\n/g, '\n'); //去除行尾空白
    str = str.replace(/&nbsp;/ig, '');//去掉&nbsp;
    return str;
}

function isThereIt(keyword, value) {
    if (value) {
        if (typeof value !== 'string') {
            value = value.toString();
        }
        if (value.toLowerCase) {
            value = value.toLowerCase();
        }
        if (value.indexOf(keyword.toLowerCase()) !== -1) {
            return true;
        }
    }

    // if (col && col.format && value) {
    //     value = col.format(row);
    //     if (!value) {
    //         return false;
    //     }
    //     if (typeof value !== 'string') {
    //         value = value.toString();
    //     }
    //     value = removeHTMLTag(value);
    //     if (value.toLowerCase) {
    //         value = value.toLowerCase();
    //     }
    //     if (value.indexOf(keyword) !== -1) {
    //         return true;
    //     }
    // }

}


export default class Store {
    constructor(table, states) {
        let me = this;


        me.table = table;
        me.states = states;

        me.states.bodyHeight = 'height: auto';
        me.states.columns = [];
        me.states.data = [];
        me.states.rows = [];
        me.states.isScroll = false;
        me.states.theaderWrapPaddingRight = 'padding-right: 0';
        // me.states.checkedList = [];

        me.filteredRows = [];
        me.searchedRows = [];
        me.sortedRows = [];

        me.checkedTimer = null;

        me.states.rows2show = [];

        me.mutations = {
            insertColumn(col) {
                me.states.columns.splice(col.idx, 0, col);
                if (col.filter) {
                    let currentColFilter = col.filter[0];
                    me.states.currentFilter[currentColFilter.field] = currentColFilter;
                    me.states.currentFilterData = currentColFilter;
                }
                me.mutations.tableResize();
            },
            removeColumn(colUuid) {
                let idx = _.findIndex(me.states.columns, ['uuid', colUuid]);
                me.states.columns.splice(idx, 1);
                me.mutations.tableResize();
            },
            setRows(rows) {
                me.states.rows = rows;
                me.doFilter();
            },
            setLoading(v) {
                me.states.loading = v;
            },
            setSearch(searchValue, searchFields) {
                me.states.search = searchValue;
                me.states.searchFields = searchFields;
                me.doSearch();
            },
            setSort() {
                me.doSort();
            },
            setPage() {
                me.doPage();
            },
            tableResize() {
                let h = $(me.table.$el).height();
                let w = $(me.table.$el).width();
                me.resizeBody(h);
                me.resizeCols(w);
            },

            changeFilter(filterItem) {
                me.states.currentFilter[filterItem.field] = filterItem;
                me.states.currentFilterData = filterItem;
                me.doFilter();
            },


            setCheckedList(list) {
                me.states.checkedList = list;
            },

            checkAll() {
                if (me.states.checkedList.length && me.states.checkedList.length == me.states.rows2show.length) {
                    me.states.checkedList = [];
                } else {
                    me.states.checkedList = me.states.rows2show;
                }
            },

            clearNotExists() {
                let checked = me.states.checkedList;
                let key = me.table.checkedKey;
                let checkedKeys = [];

                _.forEach(checked, item => {
                    checkedKeys.push(item[key]);
                });
                let rows2show = me.states.rows2show;

                let arr = [];
                _.forEach(rows2show, item => {
                    if (checkedKeys.indexOf(item[key]) != -1) {
                        arr.push(item);
                    }
                });
                me.states.checkedList = arr;
            },

            clearAll() {
                me.states.checkedList = [];
            },

            checkRow(e) {

                let selectOptions = me.states.select;
                let idx = me.states.checkedList.indexOf(e.row);
                switch(selectOptions.mode) {
                    case 'radio':
                        me.states.checkedList = [e.row];
                        break;
                    case 'checkbox':
                        if (idx === -1) {
                            me.states.checkedList.push(e.row);
                        } else {
                            let list = _.clone(me.states.checkedList);
                            list.splice(idx, 1);
                            me.states.checkedList = list;
                        }
                        break;
                    case 'switch':
                        if (idx === -1) {
                            if (e.eventOnCheckbox) {
                                me.states.checkedList.push(e.row);
                            } else {
                                me.states.checkedList = [e.row];
                            }
                        } else if (me.states.checkedList.length > 1 && !e.eventOnCheckbox) {
                            me.states.checkedList = [e.row];
                        } else {
                            let list = _.clone(me.states.checkedList);
                            list.splice(idx, 1);
                            me.states.checkedList = list;
                        }
                        break;
                }
            }
        };
    }



    resizeCols(w) {
        let totalCacheWidth = 0;
        let countOfNoWidth = 0;
        this.states.columns.forEach(c => {
            if (!c.width) {
                countOfNoWidth += 1;
            } else {
                totalCacheWidth += c.width * 1;
            }
        });
        let lessWidth = w - totalCacheWidth;
        if (this.table.select) {
            lessWidth -= 25;
        }
        let widthOfLessCol = lessWidth / countOfNoWidth;
        this.states.columns.forEach(c => {
            if (!c.width) {
                c.realWidth = widthOfLessCol;
            }
        });

    }

    resizeBody(h) {
        if (!this.states.innerScroll) {
            return;
        }

        let theaderWrapHeight = $(this.table.$refs.tableHeaderWrap).height();
        let tfootWrapHeight = $(this.table.$refs.tableFootWrap).height();

        if (isNaN(tfootWrapHeight)) {
            tfootWrapHeight = 0;
        }

        let tbodyHeight = h - theaderWrapHeight - tfootWrapHeight;

        this.states.bodyHeight = 'height: ' + tbodyHeight + 'px';
        if (!this.table.$refs.tableBodyInner) {
            return
        }
        let tableBodyInnerHeight = $(this.table.$refs.tableBodyInner.$el).height();
        this.states.isScroll = tableBodyInnerHeight > tbodyHeight;
        let paddingRight = 0;
        //if (this.states.isScroll) {
        paddingRight = getPaddingRight();
        //}
        this.states.theaderWrapPaddingRight = `padding-right: ${paddingRight}px`;

    }

// step 1
    doFilter() {
        let arr = [];
        let currentFilter = this.states.currentFilter;

        let filters = [];
        _.forEach(currentFilter, (item, field) => {
            if (item.value !== null) {
                filters.push({
                    field,
                    value: item.value
                });
            }
        });

        if (filters.length === 0) {
            arr = this.states.rows;
        } else {
            filters.forEach(f => {
                let tem = _.filter(this.states.rows, [f.field, f.value]);
                arr = arr.concat(tem);
            });
        }
        this.filteredRows = arr;
        this.doSearch();
    }

// step 2
    doSearch() {
        let filteredRows = this.filteredRows;

        let searchValue = this.states.search;
        let searchFeilds = this.states.searchFields;

        // console.log(searchValue, searchFeilds);

        if (searchValue && searchFeilds && searchFeilds.length) {
            let tem = [];
            // 遍历每一行
            _.forEach(filteredRows, (row) => {
                let hasIt = false;

                // 检查每个字段
                for (let i = 0, len = searchFeilds.length; i < len; i++) {
                    let f = searchFeilds[i];
                    let fieldValue = _.get(row, f);
                    hasIt = isThereIt(searchValue, fieldValue);
                    if (hasIt) {
                        len = 0;
                    }
                }

                if (hasIt) {
                    tem.push(row);
                }
            });
            filteredRows = tem;
        }


        this.searchedRows = filteredRows;
        this.doSort();
    }

// step 3
    doSort() {
        let sortedRows = _.clone(this.searchedRows);

        let currentSort = this.states.currentSort;

        if (!currentSort.field || !currentSort.state || !currentSort.by) {
        } else {
            let func;
            if (_.isFunction(currentSort.by)) {
                func = currentSort.by(currentSort.state);
            } else {
                func = sortFunctionList[currentSort.by](currentSort.field, currentSort.state);
            }
            sortedRows.sort(func);
        }

        this.states.sortedRows = sortedRows;
        this.doPage();
    }

// step 4
    doPage() {
        let sortedRows = this.states.sortedRows;

        if (!sortedRows) {
            return
        }


        if (!this.table.paginationOptions.enabled) {
            this.states.rows2show = sortedRows;
            if (this.table.keepChecked) {
                this.mutations.clearNotExists();
            } else {
                this.mutations.clearAll();
            }
            return
        }

        let totalRows = sortedRows.length;

        let rowsPerPage = this.table.paginationOptions.rowsPerPage;
        let currentPage = this.table.paginationOptions.current;

        if (Math.ceil(totalRows / rowsPerPage) < currentPage) {
            currentPage = 1
        }

        let currentChange = currentPage != this.table.paginationOptions.current;
        let totalRowsChange = totalRows != this.table.paginationOptions.totalRows;
        if (currentChange || totalRowsChange) {
            this.table.paginationOptions = _.assign(this.table.paginationOptions, {
                current: currentPage,
                totalRows,
                rowsPerPage
            });
            return;
        }

        let start = (currentPage - 1) * rowsPerPage;
        let end = start + rowsPerPage;
        this.states.rows2show = sortedRows.slice(start, end);
        this.mutations.tableResize();
        if (this.table.keepChecked) {
            this.mutations.clearNotExists();
        } else {
            this.mutations.clearAll();
        }
    }

    commit(name, ...args) {
        this.mutations[name](...args);
    }
};
